/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListRiskEvalReviewsSecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type ListRiskEvalReviewsSecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type ListRiskEvalReviewsSecurity = {
  option1?: ListRiskEvalReviewsSecurityOption1 | undefined;
  option2?: ListRiskEvalReviewsSecurityOption2 | undefined;
};

export type ListRiskEvalReviewsRequest = {
  /**
   * The policy whose review set to list.
   */
  policyId: string;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type ListRiskEvalReviewsSecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const ListRiskEvalReviewsSecurityOption1$outboundSchema: z.ZodMiniType<
  ListRiskEvalReviewsSecurityOption1$Outbound,
  ListRiskEvalReviewsSecurityOption1
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function listRiskEvalReviewsSecurityOption1ToJSON(
  listRiskEvalReviewsSecurityOption1: ListRiskEvalReviewsSecurityOption1,
): string {
  return JSON.stringify(
    ListRiskEvalReviewsSecurityOption1$outboundSchema.parse(
      listRiskEvalReviewsSecurityOption1,
    ),
  );
}

/** @internal */
export type ListRiskEvalReviewsSecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const ListRiskEvalReviewsSecurityOption2$outboundSchema: z.ZodMiniType<
  ListRiskEvalReviewsSecurityOption2$Outbound,
  ListRiskEvalReviewsSecurityOption2
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function listRiskEvalReviewsSecurityOption2ToJSON(
  listRiskEvalReviewsSecurityOption2: ListRiskEvalReviewsSecurityOption2,
): string {
  return JSON.stringify(
    ListRiskEvalReviewsSecurityOption2$outboundSchema.parse(
      listRiskEvalReviewsSecurityOption2,
    ),
  );
}

/** @internal */
export type ListRiskEvalReviewsSecurity$Outbound = {
  Option1?: ListRiskEvalReviewsSecurityOption1$Outbound | undefined;
  Option2?: ListRiskEvalReviewsSecurityOption2$Outbound | undefined;
};

/** @internal */
export const ListRiskEvalReviewsSecurity$outboundSchema: z.ZodMiniType<
  ListRiskEvalReviewsSecurity$Outbound,
  ListRiskEvalReviewsSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => ListRiskEvalReviewsSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => ListRiskEvalReviewsSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function listRiskEvalReviewsSecurityToJSON(
  listRiskEvalReviewsSecurity: ListRiskEvalReviewsSecurity,
): string {
  return JSON.stringify(
    ListRiskEvalReviewsSecurity$outboundSchema.parse(
      listRiskEvalReviewsSecurity,
    ),
  );
}

/** @internal */
export type ListRiskEvalReviewsRequest$Outbound = {
  policy_id: string;
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const ListRiskEvalReviewsRequest$outboundSchema: z.ZodMiniType<
  ListRiskEvalReviewsRequest$Outbound,
  ListRiskEvalReviewsRequest
> = z.pipe(
  z.object({
    policyId: z.string(),
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      policyId: "policy_id",
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
    });
  }),
);

export function listRiskEvalReviewsRequestToJSON(
  listRiskEvalReviewsRequest: ListRiskEvalReviewsRequest,
): string {
  return JSON.stringify(
    ListRiskEvalReviewsRequest$outboundSchema.parse(listRiskEvalReviewsRequest),
  );
}
